module.exports = __webpack_public_path__ + "static/media/icono2_bar_menu.a83ef7c8.webp";